module.exports = lib_ui__react_lazy_load;